import { CIcon } from '~/icons/types'

export const ciForklifts: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.315 18.83h-4.05V4.04a.5.5 0 0 0-.99 0v7.89h-1.24v-.44a.491.491 0 0 0-.49-.49h-1.54l-.52-4.49V6.5a3.952 3.952 0 0 0-3.92-3.45h-2.81a2.106 2.106 0 0 0-2.1 2.1V11h-3.01a2.443 2.443 0 0 0-2.44 2.44v4.92a.493.493 0 0 0 .49.5h1.55a3.075 3.075 0 1 1 6.15 0h1.02a3.075 3.075 0 1 1 6.15 0h.97a.5.5 0 0 0 .5-.5v-.58h1.24v1.54a.491.491 0 0 0 .49.49h4.54a.491.491 0 0 0 .49-.49.476.476 0 0 0-.48-.49Zm-9.66-6.84-1.43-1.5.43-.32a.5.5 0 0 0-.042-.82.484.484 0 0 0-.548.03l-1.81 1.36a.495.495 0 0 0 .29.89.473.473 0 0 0 .3-.1l.58-.44 1.68 1.75-.35.54H8.3l-1.65-2.07V5.15a1.108 1.108 0 0 1 1.1-1.12h2.82a2.976 2.976 0 0 1 2.94 2.6l.55 4.75-.405.61Zm4.62 4.81h-1.24v-3.88h1.24v3.88Z'
    },
    {
      d:
        'M5.321 16.766a2.092 2.092 0 1 0 .018 4.183 2.092 2.092 0 0 0-.018-4.183Zm7.179 0a2.093 2.093 0 1 0-.004 4.186 2.093 2.093 0 0 0 .004-4.186Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'forklifts',
  type: 'solid'
}
